const images = require.context("../images", true)
const audios = require.context("../audios", true)

const content = {
	imageContainerClass: "bg-extended pos-1",
	images: [
		{
			src: images("./bg.jpg"),
			class: "image-one",
			imgdiv: "imageCover",
		},
		{
			src: images("./dost_angry.gif"),
			class: "image-one dosthide",
			imgdiv: "imageCover",
		},
		{
			src: images("./dost_for_ever.gif"),
			class: "image-one dostshow",
			imgdiv: "imageCover",
		},
	],
	texts: [
		{
			textDivClass: "story-text position-top-center text-center",
			textIndivData: [
				{
					textData: "यसै गरी दुवै जना",
					textClass: "fz-5 m-0 one-line",
					timestamps: [{ start: 0 }, { start: 1 }, { start: 1.75 }, { start: 2.5 }],
				},
				{
					textData: "भनाभन गर्थे",
					textClass: "fz-5 m-0 one-line",
					timestamps: [{ start: 3.4 }, { start: 5 }],
				},
				{
					textData: "केही गरी कुरा",
					textClass: "fz-5 m-0 one-line",
					timestamps: [{ start: 6.4 }, { start: 7.2 }, { start: 8 }],
				},
				{
					textData: "मिल्यो भने दङ्ग पर्थे",
					textClass: "fz-5 m-0 one-line",
					timestamps: [{ start: 8.7 }, { start: 9.4 }, { start: 10.3 }, { start: 11.1 }],
				},
			],
		},
	],
	sounds: [
		{
			url: audios("./6.ogg"),
			delay: 1000,
		},
	],
}

export default content
